/** Single source of truth for the persona-chat route (App.tsx:266 chat/persona/:personaId). */
export const personaChatPath = (personaId: string): string => `/chat/persona/${personaId}`;
